// extracted by mini-css-extract-plugin
export default {"rules":"Entries_rules_b0920","usersControlBlock":"Entries_usersControlBlock_a1e2a","isHidden":"Entries_isHidden_d7e14","stickyHeader":"Entries_stickyHeader_ee5bb"};